// extracted by mini-css-extract-plugin
module.exports = {"reportPreload":"Report_reportPreload__34-0Y","reportText":"Report_reportText__SadHz","titleText":"Report_titleText__1Pttm"};